export default "__VITE_ASSET__BTTm6AEQ__"